import { Collapse, CollapseItem, Button, Popover, Select, Option, Table, TableColumn } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
import RacesView from '@/components/user/ranking/races-view/races-view.vue'

export default {
    name: 'SeriesResultView',
    props: ['races', 'users'],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
        'races-view': RacesView,
    },
    data() {
        return {
            activeUserId: null,
            isProcessingRaces: false,
            expandKeys:[]
        };
    },
    computed: {
        isAnyUsersLoaded() {
            return this.users && this.users.length && this.users[0].id;
        }
    },
    methods: {
        getRowKey(row) {
            return row.id;
        },
        updateRaces() {
            EventBus.$emit('series-result-update-races', this.activeUserId);
            EventBus.$emit('club-result-update-races', this.activeUserId);
        },
        loadRaceResult(activeRaceId) {
            EventBus.$emit('series-result-load-race-results', activeRaceId);
            EventBus.$emit('club-result-load-race-results', activeRaceId);
        },
        openUserData(row) {
            if (this.activeUserId == row.userId) {
                this.activeUserId = null;
                this.expandKeys = [];
                return;
            }
            this.expandKeys = [row.id];
            this.activeUserId = row.userId;
            this.updateRaces();
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/ranking/series-result-view/series-result-view.js